import { ErrorHandler } from '@angular/core';
import { IExceptionTelemetry } from '@microsoft/applicationinsights-web';

export class CustomErrorHandler implements ErrorHandler {
  handleError(error: IExceptionTelemetry): void {
     
    console.error(error);
  }
}

